/**
 * This route is dynamically added to the app if this section is
 * enabled inside the config for the tenant being built.
 */

// @ngInject
function routes($stateProvider, nsUtilProvider) {
  $stateProvider.state('dashboard', {
    parent: 'root',
    url: '/dashboard',
    templateUrl: 'apps/dashboard-gpr/templates/acp-dashboard-gpr.ng.html',
    params: {
      goToSelect: null
    },
    data: {
      permissions: {
        except: ['hub_user', 'use_dashboard_lite'],
        redirectTo: {
          hub_user: 'dashboard-hub',
          use_dashboard_lite: 'dashboard-lite'
        }
      }
    },
    resolve: {
      pageTitle: /* @ngInject */ function(module, $injector) {
        return $injector.invoke(
          nsUtilProvider.getPageTitle('apps/dashboard-gpr')
        );
      },
      module: /* @ngInject */ function($ocLazyLoad) {
        return import(/* webpackChunkName: "acp.section.dashboard-gpr" */ 'apps/dashboard-gpr').then(
          $ocLazyLoad.loadModule
        );
      }
    }
  });
}

export default routes;
